export const VideoReportClient = {
  getProgramList: "/list_program?program_category=Industry",
  getProgramListGP:
    "/list_program?program_category=Industry&for_dashboard=true",
  getSubjectsList: "/candidate/list_courses",
  getTopicsList: "/list_course_topics",
  getVideosList: "/list_topic_videos",
  getCandidateList: "/list_video_candidates",
  exportCandidates: "/export_video_candidates",
  streak_up: "/candidate_streak_up",
  learning_content_count: "/learning_content_count",
};

const RecommendationIndustryViewClient = {
  getCourseToipcUrl: "/candidate/list_topics",
  getCourseVideoUrl: "/candidate/list_videos",
  labSession: "/lab_sessions",
};

export default RecommendationIndustryViewClient;

export const AssessmentQuestionModuleClient = {
  fetch_question: "/assessment/questions/",
  resume_assessment: "/assessment/resume",
  list_assessment: "/assessment/list",
  completed_list_assessment: "/assessments/expired",
  save_answer: "/assessment/answers",
  submit_assessment: "/assessment/submit",
  logout: "/logout",
  heart_beat: "/assessment/heartbeat",
  save_code: "/save_code",
  check_subscription: "/check_subscription",
};
